import { Extension } from '@tiptap/core';

export const OriginalState = Extension.create({
   name: 'originalState',

   addOptions() {
      return {
         savedContent: '',
      };
   },

   addStorage() {
      return {
         savedContent: this.options.savedContent,
      };
   },
});
